<template>
  <md-toolbar md-elevation="0" class="bg-semanggi-500">
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">{{ $route.name }}</h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <!-- <div class="md-autocomplete">
            <md-autocomplete
              class="search"
              v-model="selectedEmployee"
              :md-options="employees"
            >
              <label>Search...</label>
            </md-autocomplete>
          </div> -->
          <md-list>
             <li class="md-list-item">
                <div class="md-list-item-content">
                  <drop-down>
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon>person</md-icon>
                      <p class="hidden-lg hidden-md">Profile</p>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li><a @click="openEditProfile()" href="#">Edit Profil</a></li>
                      <li><a @click="openAddressModal()" href="#">Alamat Saya</a></li>
                      <li><a @click="openChangePasswordModal()" href="#">Ganti Password</a></li>
                      <li><v-btn block color="error" small @click="logout()">Logout</v-btn></li>
                    </ul>
                  </drop-down>
                </div>
            </li>
            <!-- <md-list-item href="#/">
              <i class="material-icons">dashboard</i>
              <p class="hidden-lg hidden-md">Dashboard</p>
            </md-list-item> -->
            <!-- <li class="md-list-item">
                <div class="md-list-item-content">
                   <md-button
                      class="md-button md-just-icon md-simple"
                      @click="toggleUserNotificationStatus()"
                    >
                      <md-icon v-if="userNotificationStatus">notifications_active</md-icon>
                      <md-icon v-else>notifications_off</md-icon>
                      <p class="hidden-lg hidden-md">Notifications</p>
                    </md-button> -->
                  <!-- <drop-down>
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon>notifications_active</md-icon>
                      <span class="notification">5</span>
                      <p class="hidden-lg hidden-md">Notifications</p>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li><a href="#">Mike John responded to your email</a></li>
                      <li><a href="#">You have 5 new tasks</a></li>
                      <li><a href="#">You're now friend with Andrew</a></li>
                      <li><a href="#">Another Notification</a></li>
                      <li><a href="#">Another One</a></li>
                    </ul>
                  </drop-down> -->
                <!-- </div>
            </li> -->
            <!-- <li class="md-list-item"> 
              <a href="#" class="md-list-item-router md-list-item-container md-button-clean dropdown">
                <div class="md-list-item-content">
                  <drop-down>
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon>person</md-icon>
                      <p class="hidden-lg hidden-md">User</p>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right" style="padding-left:0;">
                        <li><a @click="logout()">Logout</a></li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li> -->
          </md-list>
        </div>
      </div>
    </div>
    <v-dialog v-model="editProfileVisible" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Profile</span>
        </v-card-title>
        <v-card-text class="text-center">
          <v-row>
            <v-col cols="12" sm="6" md="12">
              <span>Foto Profil</span>
              <br/>
              <br/>
              <v-avatar v-if="urlProfile == null" size="100" color="indigo">
                <v-icon class="pointer" size="100" @click="uploadFotoProfileVisible = true" dark>mdi-account-circle</v-icon>
              </v-avatar>
              <v-avatar :rounded="true" size="100" v-else>
                <img
                class="pointer"
                  @click="uploadFotoProfileVisible = true"
                  :src="urlProfile"
                  alt="Foto Profile"
                >
              </v-avatar>
              <br/>
              <br/>
              <v-btn text small v-if="urlProfile != null" @click="onRemoveImageProfile()" color="error">Hapus Foto Profil</v-btn>
            </v-col>
            <v-col cols="12" sm="6" md="12" style="padding: 0px;">
              <v-row>
                <v-col cols="6" sm="3" md="6" style="align-self:center">
                  <span>Foto Selfie</span>
                </v-col>
                <v-col cols="6" sm="3" md="6">
                  <a v-if="urlSelfie != null" :href="urlSelfie" target="_blank">Lihat Foto Selfie</a>
                  <v-file-input v-else accept="image/*" label="Foto Selfie" outlined dense hide-details="true" ref="uploadImageSelfie" @change="onUploadImageSelfie()" v-model="fileFotoSelfie"></v-file-input>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="6" md="12" style="padding: 0px;">
              <v-row>
                <v-col cols="6" sm="3" md="6" style="align-self:center">
                  <span>Foto Identitas</span>
                </v-col>
                <v-col cols="6" sm="3" md="6">
                  <a v-if="urlIdentitas != null" :href="urlIdentitas" target="_blank">Lihat Foto Identitas</a>
                  <v-file-input v-else accept="image/*" label="Foto Identitas" outlined dense hide-details="true" ref="uploadImageIdentitas" @change="onUploadImageIdentitas()" v-model="fileFotoIdentitas"></v-file-input>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="6" md="12" style="padding: 0px;">
              <v-row>
                <v-col cols="6" sm="3" md="6" style="align-self:center">
                  <span>Foto NPWP</span>
                </v-col>
                <v-col cols="6" sm="3" md="6">
                  <a v-if="urlNPWP != null" :href="urlNPWP" target="_blank">Lihat Foto NPWP</a>
                  <v-file-input v-else accept="image/*" label="Foto NPWP" outlined dense hide-details="true" ref="uploadImageNPWP" @change="onUploadImageNPWP()" v-model="fileFotoNPWP"></v-file-input>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="6" md="12">
              <v-text-field type="text" label="Nama" v-model="Account.name" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="12">
              <v-text-field type="email" label="Email" v-model="Account.email" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="12">
              <v-text-field type="text" v-mask="'###############'" label="Telepon" v-model="Account.telp" required></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeEditProfile">Close</v-btn>
          <v-btn color="blue darken-1" text @click="saveEditProfile">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="openAddressVisible" max-width="800px" persistent> 
      <v-card>
        <v-card-title>
          <span class="headline">Alamat Saya</span>
          <v-spacer></v-spacer>
          <v-btn @click="openAddAddressModal" color="primary" small dark class="mb-2">Tambah Alamat</v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-data-table 
                :headers="headerListAddress" 
                :items="userAddress"
                :single-expand="singleExpandAddress"
                :expanded.sync="addressExpanded"
                show-expand 
                hide-default-footer>
                <template v-slot:[`item.address`]="props">
                    <div>{{ props.item.address.replace(/^(.{6}[^\s]*).*/, "$1") }}...</div>
                </template>
                <template v-slot:[`item.no`]="{ item }">
                  {{(items.indexOf(item)+1) + '.'}}
                </template>
                <template v-slot:[`item.is_primary`]="{ item }">
                  {{item.is_primary ? "Ya" : "Tidak"}}
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">{{ item.name+", "+item.address+", "+item.subdistrict+", "+item.city+", "+item.province+", "+item.state+", "+item.postal_code }}</td>
                </template>
                <template v-slot:[`item.action`]="props">
                  <v-btn icon slot="activator" @click="openEditAddress(props.item)">
                    <v-icon>create</v-icon>
                  </v-btn>
                  <v-btn icon color="red" slot="activator" @click="handleDeleteAddress(props.item)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeAddress">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="openAddAddressVisible" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">
            <!-- <md-icon>notifications_off</md-icon> -->
            {{titleAddressModal}}
          </span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="12">
              <v-text-field type="text" label="Nama" v-model="newAddress.name" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="12">
              <v-textarea rows="3" label="Alamat" v-model="newAddress.address" required></v-textarea>
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-text-field type="text" label="Provinsi" v-model="newAddress.province" required></v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-text-field type="text" label="Kota" v-model="newAddress.city" required></v-text-field>
            </v-col>
            <v-col cols="8" sm="6" md="8">
              <v-text-field type="text" label="Kecamatan" v-model="newAddress.subdistrict" required></v-text-field>
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-text-field type="text" label="Kode pos" v-model="newAddress.postal_code" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-text-field type="text" label="Negara" v-model="newAddress.state" disabled required></v-text-field>
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-select
                :items="['BILLING', 'SHIPPING']"
                label="Tipe alamat"
                v-model="newAddress.type"
              ></v-select>
            </v-col>
            <v-col cols="8" sm="8" md="8">
              <v-checkbox
                v-model="newAddress.is_primary"
                label="Alamat utama?"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeAddAddressModal">Close</v-btn>
          <v-btn color="blue darken-1" text @click="saveAddress">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="changePasswordVisible" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline"><md-icon>notifications_off</md-icon>Ganti Password</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="12">
              <v-text-field type="password" label="Password lama" v-model="oldPassword" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="12">
              <v-text-field type="password" label="Password baru" v-model="newPassword" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="12">
              <v-text-field type="password" label="Ketik ulang password" v-model="passwordConf" required></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeChangePasswordModal">Close</v-btn>
          <v-btn color="blue darken-1" text @click="saveChangePassword">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="uploadFotoProfileVisible" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Foto Profile</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="12">
              <template>
                <v-file-input accept="image/*" label="Foto Profil" ref="uploadImageProfile" v-model="fileFotoProfile"></v-file-input>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeUploadImageProfile()">Close</v-btn>
          <v-btn color="blue darken-1" text @click="onUploadImageProfile()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </md-toolbar>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {forEach,slice,isEmpty,orderBy,find,countBy} from "lodash";
export default {
  data() {
    return {
      selectedEmployee: null,
      userLogin: "",
      userNotificationStatus: false,
      employees: [
        "Jim Halpert",
        "Dwight Schrute",
        "Michael Scott",
        "Pam Beesly",
        "Angela Martin",
        "Kelly Kapoor",
        "Ryan Howard",
        "Kevin Malone"
      ],
      editProfileVisible: false,
      changePasswordVisible: false,
      uploadFotoProfileVisible: false,
      openAddressVisible: false,
      openAddAddressVisible: false,
      isAddressEdited: false,
      titleAddressModal: "Tambah Alamat",
      oldPassword: '',
      newPassword: '',
      passwordConf: '',
      userLogin: {},
      newAddress: {
        name: '',
        address: '',
        subdistrict: '',
        city: '',
        province: '',
        state: 'INDONESIA',
        postal_code: '',
        is_primary: 0,
        type: ''
      },
      Account: {
        name: '',
        email: '',
        telp: '',
        address: ''
      },
      userAddress: [
        {
          address: "Jalan Kalilom Lor Timur 2/1",
          subdistrict: "Kenjeran",
          city: "Surabaya",
          province: "Jawa Timur",
          state: "Indonesia",
          postal_code: "60129",
          is_primary: 1
        }
      ],
      addressExpanded: [],
      singleExpandAddress: true,
      headerListAddress: [
        { text: 'Nama', align: 'text-left', value: 'name' },
        { text: "Alamat", align: "text-center", value: "address" },
        { text: "Kecamatan", align: "text-center", value: "subdistrict" },
        { text: "Kota", align: "text-center", value: "city" },
        { text: "Utama", align: "text-center", value: "is_primary" },
        { text: "Actions", align: "text-center", value: "action", },
        { text: '', value: 'data-table-expand' }
      ],
      urlProfile: null,
      dataFotoProfile: null,
      fileFotoProfile: null,
      urlIdentitas: null,
      dataFotoIdentitas: null,
      fileFotoIdentitas: null,
      urlNPWP: null,
      dataFotoNPWP: null,
      fileFotoNPWP: null,
      urlSelfie: null,
      dataFotoSelfie: null,
      fileFotoSelfie: null
    };
  },
  computed: {
    ...mapGetters({
      getAddress: "address/getAddress"
    }),
    formTitle() {
      return this.companyData == null
        ? "Add Company Details"
        : "Update Company Details";
    }
  },
  methods: {
    ...mapActions({
      logOut: "auth/logOut",
      toggleNotificationStatus: "user/toggleUserNotificationStatus",
      changePassword: "user/changePassword",
      userProfile: "user/userProfile",
      updateUserProfile: "user/updateUserProfile",
      createAddress: "address/createAddress",
      updateAddress: "address/updateAddress",
      deleteAddress: "address/deleteAddress",
      uploadImageProfile: "user/uploadImageProfile",
      updateImageProfile: "user/updateImageProfile",
      removeImageProfile: "user/removeImageProfile",
      uploadImageSelfie: "user/uploadImageSelfie",
      uploadImageIdentitas: "user/uploadImageIdentitas",
      uploadImageNPWP: "user/uploadImageNPWP",
      getUser: "auth/getUserData",
    }),
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    async toggleUserNotificationStatus() {
      this.userNotificationStatus = !this.userNotificationStatus;
      await this.toggleNotificationStatus({
        status: this.userNotificationStatus,
        fcm_token: localStorage.getItem("fcm_token")
      });
      this.userLogin.notification_status = !this.userNotificationStatus;
      window.localStorage.setItem("is_notification", this.userNotificationStatus);
    },
    logout() {
      let result = confirm("Are you sure you want to logout?");
      if(result){
        this.logOut()      
      }
    },
    async openAddressModal() {
      const response = await this.getAddress; 
      this.userAddress = response.data.attributes;
      this.openAddressVisible = true;
    },
    closeAddress() {
      this.openAddressVisible = false;
    },
    openAddAddressModal() {
      this.openAddAddressVisible = true;
      this.titleAddressModal = "Tambah Alamat";
      this.newAddress = {
        name: '',
        address: '',
        subdistrict: '',
        city: '',
        province: '',
        state: 'INDONESIA',
        postal_code: '',
        is_primary: 0,
        type: ''
      }
    },
    openEditAddress(address) {
      this.isAddressEdited = true;
      this.openAddAddressVisible = true;
      this.titleAddressModal = "Edit Alamat";
      this.editedIndex = this.userAddress.indexOf(address);
      this.newAddress = {
        ...address
      };
    },
    closeAddAddressModal() {
      this.openAddAddressVisible = false;
      this.isAddressEdited = false;
    },
    async saveAddress() {
      let response;
      this.newAddress.user_id = this.userLogin.id
      if(this.titleAddressModal === "Edit Alamat") {
        response = await this.updateAddress({
          ...this.newAddress,
          user_id: this.userLogin.id
        });
        if(response.status === 200) {
          this.$notify({
            group: 'custom-notification',
            type: 'success',
            title: 'Success!',
            text: 'Alamat berhasil diperbarui!'
          });
          Object.assign(this.userAddress[this.editedIndex], response.data.attributes);
          this.openAddAddressVisible = false;
        }
      }else{
        response = await this.createAddress({
          ...this.newAddress,
          user_id: this.userLogin.id
        });
        if(response.status === 200) {
          this.$notify({
            group: 'custom-notification',
            type: 'success',
            title: 'Success!',
            text: 'Alamat baru berhasil ditambahkan!'
          });
          this.userAddress.push(response.data.attributes)
          this.openAddAddressVisible = false;
        }
      }
    },
    async handleDeleteAddress(address) {
      const index = this.userAddress.indexOf(address);
      const response = await this.deleteAddress(address.id);
      if(response.status === 200) {
        this.$notify({
          group: 'custom-notification',
          type: 'success',
          title: 'Success!',
          text: 'Alamat berhasil dihapus!'
        });
        this.userAddress.splice(index, 1);
      }
    },
    async openEditProfile() {
      const response = await this.userProfile()
      const user = await this.getUser()

      forEach(user.data.attributes.user_attachment, attachment => {
        if(attachment.attachment_type == 'PROFIL'){
          this.urlProfile = process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL + '/' + attachment.location + '/' + attachment.name
          this.dataFotoProfile = attachment
        }else if(attachment.attachment_type == 'SELFIE'){
          this.urlSelfie = process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL + '/' + attachment.location + '/' + attachment.name
          this.dataFotoSelfie = attachment
        }else if(attachment.attachment_type == 'NPWP'){
          this.urlNPWP = process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL + '/' + attachment.location + '/' + attachment.name
          this.dataFotoNPWP = attachment
        }else if(attachment.attachment_type == 'IDENTITAS'){
          this.urlIdentitas = process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL + '/' + attachment.location + '/' + attachment.name
          this.dataFotoIdentitas = attachment
        }
      })

      const userProfile = response.data && response.data.attributes ? response.data.attributes : {}
      this.Account = {
        name: userProfile.name,
        email: userProfile.email,
        telp: userProfile.telp,
        address_id: userProfile.address.length && userProfile.address[0] > 0 ? userProfile.address[0].id : '',
        address: userProfile.address.length && userProfile.address[0] > 0 ? userProfile.address[0].address : ''
      }
      this.editProfileVisible = true;
    },
    closeEditProfile() {
      this.editProfileVisible = false;
    },
    async saveEditProfile() {
      const response = await this.updateUserProfile({
        ...this.Account
      });
      if(response.status === 200){
        this.$notify({
          group: 'custom-notification',
          type: 'success',
          title: 'Success!',
          text: 'Profil updated!'
       });
      }
      
      this.editProfileVisible = false;
    },
    openChangePasswordModal() {
      this.changePasswordVisible = true;
    },
    closeChangePasswordModal() {
      this.changePasswordVisible = false;
    },
    async saveChangePassword() {
      try{
        const response = await this.changePassword({
          old_password: this.oldPassword,
          new_password: this.newPassword,
          password_conf: this.passwordConf
        });
        if(response.status === 200){
          this.$notify({
            group: 'custom-notification',
            type: 'success',
            title: 'Success!',
            text: 'Password changed!'
          });
        }
        this.changePasswordVisible = false;
        setTimeout(this.logOut, 3000)
      }catch(e) {
        console.log(e)
      }
    },
    async onUploadImageProfile() {
      try{
        const data = new FormData()
        data.append('profile', this.fileFotoProfile)

        if(this.urlProfile == null){
          const response = await this.uploadImageProfile(data)
          if(response.status === 200){
            this.$notify({
              group: 'custom-notification',
              type: 'success',
              title: 'Success!',
              text: 'Upload foto profil berhasil!'
            });
            this.dataFotoProfile = response.data.data
            this.urlProfile = process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL + '/' + response.data.data.location + '/' + response.data.data.name
          }
        }else{
          const response = await this.updateImageProfile({'id' : this.dataFotoProfile.id, 'data' : data})
          if(response.status === 200){
            this.$notify({
              group: 'custom-notification',
              type: 'success',
              title: 'Success!',
              text: 'Update foto profil berhasil!'
            });
            this.dataFotoProfile = response.data.data
            this.urlProfile = process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL + '/' + response.data.data.location + '/' + response.data.data.name
          }          
        }
        this.closeUploadImageProfile()
      }catch(e) {
        console.log(e)
      }
    },
    async onUploadImageSelfie() {
      try{
        const data = new FormData()
        data.append('selfie', this.fileFotoSelfie)

        const response = await this.uploadImageSelfie(data)
        if(response.status === 200){
          this.$notify({
            group: 'custom-notification',
            type: 'success',
            title: 'Success!',
            text: 'Upload foto selfie berhasil!'
          });
          this.dataFotoSelfie = response.data.data
          this.urlSelfie = process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL + '/' + response.data.data.location + '/' + response.data.data.name
        }
      }catch(e) {
        console.log(e)
      }
    },
    async onUploadImageIdentitas() {
      try{
        const data = new FormData()
        data.append('identitas', this.fileFotoIdentitas)

        const response = await this.uploadImageIdentitas(data)
        if(response.status === 200){
          this.$notify({
            group: 'custom-notification',
            type: 'success',
            title: 'Success!',
            text: 'Upload foto identitas berhasil!'
          });
          this.dataFotoIdentitas = response.data.data
          this.urlIdentitas = process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL + '/' + response.data.data.location + '/' + response.data.data.name
        }
      }catch(e) {
        console.log(e)
      }
    },
    async onUploadImageNPWP() {
      try{
        const data = new FormData()
        data.append('npwp_user', this.fileFotoNPWP)

        const response = await this.uploadImageNPWP(data)
        if(response.status === 200){
          this.$notify({
            group: 'custom-notification',
            type: 'success',
            title: 'Success!',
            text: 'Upload foto NPWP berhasil!'
          });
          this.dataFotoNPWP = response.data.data
          this.urlNPWP = process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL + '/' + response.data.data.location + '/' + response.data.data.name
        }
      }catch(e) {
        console.log(e)
      }
    },
    async onRemoveImageProfile() {
      try{
        const response = await this.removeImageProfile(this.dataFotoProfile.id)
        if(response.status === 200){
          this.$notify({
            group: 'custom-notification',
            type: 'success',
            title: 'Success!',
            text: 'Hapus foto profil berhasil!'
          });
          this.urlProfile = null
          this.dataFotoProfile = null
        }
      }catch(e) {
        console.log(e)
      }
    },
    closeUploadImageProfile() {
      this.uploadFotoProfileVisible = false
      this.fileFotoProfile = null
    },
    editableSave() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    },
    editableCancel() {
      // this.snack = true;
      // this.snackColor = "error";
      // this.snackText = "Canceled";
    },
    editableOpen() {
      // this.snack = true;
      // this.snackColor = "info";
      // this.snackText = "Dialog edit opened";
    },
    editableClose() {
      // console.log("Dialog closed");
    }
  },
  async created() {
    const userLogin = JSON.parse(window.localStorage.getItem("user_data"));
    this.userLogin = userLogin;
    this.userNotificationStatus = this.userLogin.notification_status === 1 ? true : false;
    window.localStorage.setItem("is_notification", this.userNotificationStatus); 
  }
};
</script>

<style scoped>
  .dropdown-menu{
    padding-left: 0 !important;
  }
  .pointer{
    cursor: pointer;
  }
  .bg-semanggi-500{
    background-color: #0fa966 !important;
  }
</style>
